<template>
  <div class="pt-16">
    <h2 class="pt-6 pb-3">Logs</h2>
    <v-container>
      <v-card>
        <v-row no-gutters style="height: 150px" align="center">
          <v-col cols="3" class="pl-4 pr-8">
            <v-select
              v-model="selectedLog"
              @change="getLogs"
              :items="logType"
            ></v-select>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-container>
      <v-card class="mt-5">
        <v-alert v-if="errorMessage" text type="error">
          {{ errorMessage }}
        </v-alert>
        <ag-grid-vue
          style="height: 500px"
          class="ag-theme-balham"
          :columnDefs="columnDefs"
          :gridOptions="gridOptions"
          :defaultColDef="defaultColDef"
          :frameworkComponents="frameworkComponents"
          :rowData="rowData"
        >
        </ag-grid-vue>
      </v-card>
    </v-container>
  </div>
</template>
<style lang="css" scoped>
.text-left {
  text-align: left;
}
</style>
<script>
import { AgGridVue } from "ag-grid-vue";
import { HTTP } from "@/http-common";
import DownloadLogs from "@/components/download-logs";
export default {
  name: "ImportWcgCharge",
  components: {
    AgGridVue,
  },
  data: () => ({
    gridApi: {},
    gridColumnApi: {},
    gridOptions: {},
    defaultColDef: {
      resizable: true,
    },
    columnDefs: null,
    rowData: [],
    selectedLog: "All",
    logType: [
      { text: "All", value: "All" },
      { text: "VoIP services", value: "bulkUploadVoipServices" },
      { text: "Misc Transactions", value: "bulkUploadTransactions" },
      { text: "New Mobiles", value: "bulkUploadMobileServices" },
      { text: "New Customers", value: "bulkUploadCustomers" },
      { text: "Disconnect Services", value: "bulkUploadDisconnectServices" },
      { text: "NBN Services", value: "bulkUploadNBNServices" },
      { text: "MNF Agents", value: "BulkUploadInterestedAgents_44" },
    ],
    errorMessage: "",
    frameworkComponents: null,
  }),
  mounted() {
    let vm = this;
    vm.gridApi = vm.gridOptions.api;
    vm.gridColumnApi = vm.gridOptions.columnApi;
    vm.gridApi.sizeColumnsToFit();
    vm.getLogs();
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = { defaultToolPanel: "" };
    vm.columnDefs = [
      {
        headerName: "Type",
        field: "type",
        cellClass: "text-left",
      },
      {
        headerName: "File Name",
        field: "fileName",
        cellClass: "text-left",
      },
      {
        headerName: "Date Uploaded",
        field: "dateUploaded",
        cellClass: "text-left",
      },
      {
        headerName: "Uploaded By",
        field: "uploader",
        cellClass: "text-left",
      },
      {
        headerName: "Actions",
        field: "action",
        cellRenderer: "downloadBtn",
        cellRendererParams: {
          clicked: function(param) {
            vm.downloadLog(param);
          },
        },
        editable: false,
      },
    ];
    vm.frameworkComponents = {
      downloadBtn: DownloadLogs,
    };
  },

  methods: {
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
      vm.gridApi.sizeColumnsToFit();
    },
    downloadLog(fileName) {
      return new Promise(async (reject) => {
        try {
          var response = await HTTP.get(
            `BulkUpload/DownloadBulkUploadLogs/${fileName}`,
            { responseType: "blob" }
          );
        } catch (err) {
          dispatch(
            "setMessage",
            new httpError({ message: err.message, httpStatus: 500 })
          );
          alert(err.message);
          reject(err);
        }
        {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: response.type })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        }
      });
    },
    getLogs() {
      let vm = this;
      vm.errorMessage = "";
      return new Promise((resolve, reject) => {
        let response = HTTP.get(
          `BulkUpload/BulkUploadLogs/${this.selectedLog}`
        );
        response
          .then((data) => {
            if (!data.data.success) {
              vm.errorMessage = data.data.message;
              vm.rowData = [];
              setTimeout(() => {
                vm.errorMessage = "";
              }, 2000);
              return;
            }
            vm.rowData = data.data.data;
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
</script>
